export enum ControlType {
    SingleLineText = "SingleLineText",
    MultiLineText = "MultiLineText",
    Select = "Select",
    Checkbox = "Checkbox",
    Sensitive = "Sensitive",
    StepName = "StepName",
    AzureAccount = "AzureAccount",
    Certificate = "Certificate",
    WorkerPool = "WorkerPool",
    AmazonWebServicesAccount = "AmazonWebServicesAccount",
    UsernamePasswordAccount = "UsernamePasswordAccount",
    GoogleCloudAccount = "GoogleCloudAccount",
    GenericOidcAccount = "GenericOidcAccount",
    Package = "Package",
    Custom = "Custom",
    TargetTags = "TargetTags",
    Feed = "Feed",
    Environments = "Environments",
    TenantTags = "TenantTags",
    Teams = "Teams",
    Channels = "Channels",
    Project = "Project"
}
export function isResourceControlType(controlType: ControlType | undefined): boolean {
    return controlType
        ? [
            ControlType.AzureAccount,
            ControlType.Certificate,
            ControlType.WorkerPool,
            ControlType.AmazonWebServicesAccount,
            ControlType.UsernamePasswordAccount,
            ControlType.GoogleCloudAccount,
            ControlType.GenericOidcAccount,
            ControlType.Package,
            ControlType.Feed,
            ControlType.Environments,
            ControlType.TenantTags,
            ControlType.Channels,
            ControlType.Project,
        ].includes(controlType)
        : false;
}
